export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 课程编号
                // courseNumber: '',
                // 课程名称
                courseName: '',
                // 课程类型
                courseType: '',
                // 课程分类
                courseClassification: '',
                // 课程分类路径
                // path: '',
                // 大于或等于报名期限
                // time_egt: '',
                // 小于或等于报名期限
                // time_eglt: '',
                // 课程状态
                // courseState: '',
                // 申报年度
                year: '',
                // 课程简介
                desc: '',
                // 讲师
                teacher: '',
                // 讲师简介
                teacherDesc: '',
                // 是否上架
                shelves: true,
                // 是否禁用
                // disable: false,
                // 课程标签
                // label: '',
                // 提供者
                provider: '',
                // 备注
                remark: '',
                // 所属中心
                // center: '',
            },
            // 课程类型
            courseType: [
                {
                    id: 1,
                    label: '公需课',
                    value: '公需课',
                },
                {
                    id: 2,
                    label: '专业课',
                    value: '专业课',
                },
                {
                    id: 3,
                    label: '选修课',
                    value: '选修课',
                },
                {
                    id: 4,
                    label: '其他',
                    value: '其他',
                }
            ],
			courseClassification:'',
            // 课程分类
            courseClassificationList: [],
            // 课程状态
            courseState: [
                {
                    id: 1,
                    label: '未上架',
                    value: '未上架',
                },
                {
                    id: 2,
                    label: '待审核',
                    value: '待审核',
                },
                {
                    id: 3,
                    label: '已上架',
                    value: '已上架',
                },
                {
                    id: 4,
                    label: '已过期',
                    value: '已过期',
                },
            ],
            // 课程标签
            courseLabels: [
                {
                    id: 1,
                    label: '标签1',
                    value: '标签1'
                },
                {
                    id: 2,
                    label: '标签2',
                    value: '标签2'
                },
            ],
            // 所属中心
            center: [
                {
                    id: 1,
                    label: '郑州',
                    value: '郑州'
                }
            ],
            // 表格数据
            tableData: [],
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 导入课程对话框
            importCourseDialog: false,
            // 导入附件对话框
            importAccessoryDialog: false,
            // 下载导入模板
            download: '',
            // 上传的课程导入地址
            address01: '',
            // 上传的附件导入地址
            address02: '',
            // 新增课程对话框
            addCourseDialog: false,
            // 新增课程的数据
            addform: {
                courseNumber: '',
                courseName: '',
                courseType: '',
                courseClassificatio: '',
                // path: '',
                // time_egt: '',
                // time_eglt: '',
                entryFee: '',
                shelves: true,
                // courseState: '',
                year: '',
                period: '',
                teacher: '',
                displayPosition: '',
                previewLink: '',
                // disable: false,
                // label: '',
                provider: '',
                remark: '',
                imageUrl: '',
                desc: '',
                teacherDesc: '',
                courseDetail: '',
            },
            // 修改信息时上传图片的地址
            address03: this.baseUrl + 'file/upload_img?token=' + this.$store.state.authority_management,
            // 新增课程中的课程资源数据
            courseTableData: [
                {
                    id: 1,
                    title: '标题111',
                    type: '选修课',
                    fileName: '视频1',
                    label: '标签1',
                    fileLength: '300',
                    operation: '操作',
                },
                {
                    id: 2,
                    title: '标题111',
                    type: '选修课',
                    fileName: '视频1',
                    label: '标签1',
                    fileLength: '300',
                    operation: '操作',
                },
                {
                    id: 3,
                    title: '标题111',
                    type: '选修课',
                    fileName: '视频1',
                    label: '标签1',
                    fileLength: '300',
                    operation: '操作',
                },
            ],
            // 新增课程中需要删除的课程资源的id
            deleteIds: [],
            // 上传资源的地址
            address04: '',
            // 上传资源的标题
            title: '',
            // 上传资源的标签
            label: '',
            // 修改课程对话框
            editCourseDialog: false,
            // 修改课程的数据
            editform: {},
            // 修改课程中需要删除的课程资源的id
            deleteIds2: [],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
        }
    },
    methods: {
        // 搜索
        search() {
            this.currentPage = 1;
            this.getData();
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 点击新增课程按钮
        handleNewCourse() {
            this.addCourseDialog = true;
        },

        // 上传
        httpreq01(q) {
            this.$upload(this.address01, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 上传
        httpreq02(q) {
            this.$upload(this.address02, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 上传
        httpreq03(q) {
			console.log('上传')
            this.$upload(this.address03, q).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('图片上传成功，请不要修改图片链接');
                    // 赋值
                    this.editform.image = res.data.result;
					this.editCourse()
                } else {
                    this.$message.error('图片上传失败，请稍后重试');
                }
            });
        },

        // 上传
        httpreq04(q) {
            this.$upload(this.address04, q).then(res => {
                this.$message({
                    message: '导入完成',
                    type: 'success'
                });
            });
        },

        // 添加课程
        addCourse() {
            this.addCourseDialog = false;
			
            this.$message.success('添加课程成功！');
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange2(selections) {
            // 取出选择的表格行的id
            this.deleteIds = selections.map(item => item.id);
        },

        // 删除选中的课程资源
        deleteCourseResources() {
            // 先判断是否有选择记录
            if (this.deleteIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
        },

        // 点击修改课程按钮
        handleEditCourse() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            // 赋值
            this.editform = this.selections[0];
            // 将是否上架由1和0改为true和false，以便在checkbox上使用
            this.editform.onsale == 1 ? this.editform.onsale = true : this.editform.onsale = false;

            // 显示修改课程对话框
            this.editCourseDialog = true;
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange3(selections) {
            // 取出选择的表格行的id
            this.deleteIds2 = selections.map(item => item.id);
        },

        // 删除选中的课程资源
        deleteCourseResources2() {
            // 先判断是否有选择记录
            if (this.deleteIds2.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
        },

        // 保存修改课程
        editCourse() {
			let data = {
				token: this.$store.state.authority_management,
				product_id: this.editform.id,
				onsale: this.editform.onsale == true ? 1 : 0,
			}
			
			if(this.editform.course_name){
				data.course_name = this.editform.course_name
			}
			
			if(this.editform.attr){
				data.attr = this.editform.attr
			}
			
			if(this.editform.year){
				data.year = this.editform.year
			}
			
			if(this.editform.desc){
				data.desc = this.editform.desc
			}
			
			if(this.editform.teacher){
				data.teacher = this.editform.teacher
			}
			
			if(this.editform.teacher_intro){
				data.teacher_intro = this.editform.teacher_intro
			}
			
			if(this.editform.provider){
				data.provider = this.editform.provider
			}
			
			if(this.editform.remark){
				data.remark = this.editform.remark
			}
			
			if(this.editform.sort){
				data.sort = this.editform.sort
			}
			
			if(this.editform.period){
				data.period = this.editform.period
			}
			
			if(this.editform.price){
				data.price = this.editform.price
			}
			
			if(this.editform.image){
				data.image = this.editform.image
			}
			
			
			
			
            this.$post('products/editCourse', data).then(res => {
				console.log(res)
				if(res.data.status == 'success'){
						console.log(this.$refs)
						this.$refs.upload.clearFiles()
						
						
						this.$message.success('修改成功！');
						this.editCourseDialog = false;
						this.getData();
						this.editform = {};
				}else{
					this.$message.error('修改失败！');
				}
                
            })
        },

        // 点击删除课程按钮
        handleDeleteCourse() {
            // 先判断是否有选择记录且最多选择一条记录
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 发送请求删除
                this.$post('products/deleteCourse', {
                    token: this.$store.state.authority_management,
                    ids: JSON.stringify(this.selectionIds)
                }).then(res => {
                    this.$message.success('删除成功！');

                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },

        // 获取数据
        getData() {
            this.$post('products/courseList', {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                course_name: this.form.courseName,
                attr: this.form.courseType,
                category_name: this.form.courseClassification,
                year: this.form.year,
                desc: this.form.desc,
                teacher: this.form.teacher,
                teacher_intro: this.form.teacherDesc,
                onsale: this.form.shelves ? 1 : 0,
                provider: this.form.provider,
                remark: this.form.remark,
                // sort: this.form.center,
            }).then(res => {
                this.total = res.data.result.total;
                this.tableData = res.data.result.result;
            });
        },

        // 获取课程包数据
        getCoursePackageData() {
            this.$post('product_category/categoryList', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 99999
            }).then(res => {
				this.courseClassificationList = res.data.result;
            })
        }
    },
    filters: {
        onsaleFilter(value) {
            return value == 1 ? '已上架' : '未上架';
        },

        disableFilter(value) {
            return value ? '已禁用' : '未禁用';
        }
    },
    created() {
        // 获取数据
        this.getData();
        this.getCoursePackageData();
    }
}